module.exports = __webpack_public_path__ + "img/fixed-area.3e037a9a.svg";